import InventairesTab from "@features/stock/components/InventairesTab";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/inventaires/")({
  component: InventairesTab,
});
